import clsx from 'clsx';
import React from 'react';

import { TextButton } from '@components/Button/variants';

import { TitleSizes } from './constants';
import type { ForYouSectionHeaderProps } from './interfaces';

const ForYouSectionHeader = ({
  headerLink,
  headerLinkText,
  highlight,
  subtitle,
  title,
  titleSize = TitleSizes.Small,
}: ForYouSectionHeaderProps) => {
  if (!headerLink && !headerLinkText && !highlight && !subtitle && !title) {
    return null;
  }

  return (
    <header
      className={clsx({
        'flex flex-row items-center justify-between': headerLink && headerLinkText,
      })}
    >
      {highlight && (
        <span className="hidden font-suisse-intl-mono text-caption-lg font-normal text-primary-magenta sm:block">
          {highlight}
        </span>
      )}
      <h2
        className={clsx(
          'm-0 font-suisse-screen text-headline-alt-sm text-grayscale-charcoal sm:text-headline-lg',
          {
            'md:text-headline-alt-lg': titleSize === TitleSizes.Large,
          }
        )}
      >
        {title}
      </h2>
      {subtitle && (
        <p className="mb-0 mt-8 font-suisse-neue text-body-md font-normal sm:text-subheadline-sm">
          {subtitle}
        </p>
      )}
      {headerLink && headerLinkText && (
        <TextButton
          as="link"
          href={headerLink}
          className="mt-0 !justify-end leading-[28px] sm:mt-8 sm:leading-[52px]"
        >
          {headerLinkText}
        </TextButton>
      )}
    </header>
  );
};

export default ForYouSectionHeader;
